import { MicrobiomeTest } from '@snapi/types';
import { format } from 'date-fns';
import Link from 'next/link';

type MyTestCardProps = Pick<MicrobiomeTest, 'id' | 'createdAt'>;

export const MyTestCard = ({ id, createdAt }: MyTestCardProps) => (
  <Link href={`/dashboard/report/${id}`} passHref>
    <a className="flex flex-1 h-[60px] p-3 bg-white rounded-[10px]">
      <span className="flex w-10 h-10 rounded-full bg-blue-light" />
      <div className="flex flex-col justify-center ml-3">
        <h5>{id}</h5>
        <small>{format(new Date(createdAt), 'MMM do, yyyy')}</small>
      </div>
    </a>
  </Link>
);
